// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"432":"c064d1e8","441":"35687c66","453":"3c8b9613","650":"749fccff","670":"99328e7d","720":"c7906101","797":"7527ba8d"}[chunkId] + ".chunk.js";
};